import { useTranslation } from "react-i18next";

import { FilterHeader } from "@shared/table/headers/FilterHeader";

type Props<T extends string> = {
    // Translated label per status; its key order is the order of the options.
    labels: Record<T, string>;
    value: T[];
    onChange: (value: T[]) => void;
};

export const StatusHeader = <T extends string>({ labels, value, onChange }: Props<T>) => {
    const { t } = useTranslation(["modals"]);
    const statuses = Object.keys(labels) as T[];

    return (
        <FilterHeader
            title={t("modals:filterDialog.variants.status")}
            sortDisabled
            options={statuses.map((status) => ({ key: status, label: labels[status] }))}
            initialValues={Object.fromEntries(statuses.map((status) => [status, value.includes(status)]))}
            onSubmit={(values) => onChange(statuses.filter((status) => values[status]))}
        />
    );
};
